export default __webpack_public_path__ + "static/media/cat3.8f2e6dec.png";